import { render } from "./TreeSelect.vue?vue&type=template&id=23a8d608&ts=true"
import script from "./TreeSelect.ts?vue&type=script&lang=ts&external"
export * from "./TreeSelect.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__